import { type MotionProps } from "framer-motion";

export const animation: MotionProps = {
  initial: { opacity: 0, scale: 0.4 },
  whileInView: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.4 },
  transition: { delay: 0 },
  viewport: { once: true },
};
